import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/dimensions/width-height/width-height.js";
import "dabbyjs/src/utils/extend/extend.js";
import getBase from "../../javascript/base.js";

export default obj => {
	if (obj.length) {
		import(getBase() + "javascript/chart.min.js?v=2.9.3").then(() => {
			const resize = 500,
				print = window.matchMedia("print").matches;

			// read the default font
			Chart.defaults.global.defaultFontFamily = $("body").css("font-family");
			const heading = $("<h1>").appendTo("body"),
				titlefont = heading.css("font-family");
			heading.remove();

			// defaults
			Chart.defaults.global.defaultFontColor = "#000";
			if (print) {
				Chart.defaults.global.animation = 0;
			}

			// create charts for each object
			obj.each(function () {
				const $this = $(this),
					data = $this.data("chart"),
					width = obj.width();

				if (data.type === "line") {

					// add time parser
					data.options.scales.xAxes.map((item, key) => {

						// add time parser
						if (item.type === "time") {
							item.time.parser = date => {
								const obj = {};

								// compile date values into format fields
								date = date.toString();
								"yyyymmddhhiiss".split("").forEach((f, i) => {
									if (!obj[f]) {
										obj[f] = "";
									}
									if (date[i]) {
										obj[f] += date[i];
									}
								});
								return new Date(obj.y, obj.m-1, obj.d, obj.h, obj.i, obj.s);
							}
						}
						return item;
					});

					// add label callbacks
					data.options.scales.yAxes.map((item, key) => {

						// add percentage onto progress scale
						if (item.suffix) {
							item.ticks.callback = label => label + item.suffix;
						}

						// hide tick label before the specified value
						if (typeof item.mindisplay === "number") {
							item.ticks.callback = label => (label < item.mindisplay) ? "" : label;
						}
						return item;
					});
				}
				// render the chart
				const chart = new Chart(
					this.getContext("2d"),
					{
						type: data.type,
						data: {
							labels: data.labels,
							datasets: data.data
						},
						options: $.extend(
							true,
							{
								maintainAspectRatio: false, // works better like this, can control through CSS
								animationSteps: 60,

								// style tooltips
								tooltips: $.extend( {
									mode: "index",
									position: "nearest",
									caretSize: 10,
									backgroundColor: "#F8F8F8",
									titleFontFamily: titlefont,
									titleFontSize: 16,
									titleFontStyle: "normal",
									titleFontColor: "#000",
									titleSpacing: 10,
									bodyFontSize: 13,
									bodySpacing: 10,
									bodyFontColor: "#000",
									cornerRadius: 0,
									displayColors: true,
									xPadding: 10,
									yPadding: 10,
								}, data.labels && (["pie", "doughnut"].indexOf(data.type) > -1) ? {} : {
									callbacks: {
										title: item => (data.titles || data.labels)[item[0].index],
										label: (item, options) => {
											return options.datasets[item.datasetIndex].label + ": " + (Number.isNaN(item.yLabel) ? data.null : item.yLabel + (options.datasets[item.datasetIndex].suffix || ""));
										}
									}
								})
							},
							data.hrefs ? {
								onClick: e => {
									if (obj.width() > resize) {
										const element = chart.getElementAtEvent(e)[0];
										if (element && data.hrefs[element._index]) {
											window.location.href = data.hrefs[element._index];
										}
									}
								}
							} : {},
							data.type === "radar" ? {

								// makes legend labels smaller when resized
								onResize: (inst, size) => {
									inst.options.legend.labels.fontSize = size.width <= resize ? 10 : 14;
								},
								scale: {

									// hide the point labels when small screen and make sure they are not too long
									pointLabels: {
										callback: (label, i, labels) => {
											const width = obj.width();

											// hide labels if under 500px
											if (width <= 500) {
												return false;

											// trim labels if under 1024px
											} else if (width <= 1024 && label.length > 20) {
												label = label.slice(0, 20) + "...";
											}

											// lift label up
											if (!i) {
												return [label, ""];
											}

											// push label down
											if (i === labels.length / 2) {
												return ["", label];
											}
											return label;
										},
										fontSize: 14
									},
									gridLines: {
										color: "#CCC",
										circular: true
									},
									ticks: { // makes the first inner tick blank
										callback: (value, index) => index ? value : ""
									}
								},
								legend: {
									labels: {
										fontSize: width <= resize ? 10 : 14
									}
								}
							} : {},
							data.options
						)
					}
				);
			});
		});
	}
};
